import {makeActionCreator} from '../utility'

export const FETCH_USER_BILLS = 'FETCH_USER_BILLS'
export const fetchUserBills = makeActionCreator(FETCH_USER_BILLS, 'data')

export const USER_BILLS_RECEIVED = 'USER_BILLS_RECEIVED'
export const userBillsReceived = makeActionCreator(USER_BILLS_RECEIVED, 'data')


export const FETCH_BILLER_DETAILS = 'FETCH_BILLER_DETAILS'
export const fetchBillerDetails = makeActionCreator(FETCH_BILLER_DETAILS, 'data')


export const BILLER_DETAILS_RECEIVED = 'BILLER_DETAILS_RECEIVED'
export const billerDetailsReceived = makeActionCreator(BILLER_DETAILS_RECEIVED, 'data')